import React, { Component } from 'react'
import { FormattedDate, FormattedMessage, FormattedTime, injectIntl } from 'react-intl'
import Icon from "../common/icon/icon.component.jsx";
import { Link } from "react-router-dom";
import InlineEditUser from "../common/inline-edit/user.component.jsx";
import GlobalHelper from "../common/GlobalHelper.jsx";
import QuoteEventsTimeLine from "../quote/analytics/eventstimeline.component.jsx";
import UrlRegex from "../common/regex/urlregex.component.jsx";
import DisplayReferences from "./displayreferences.component.jsx";
import InternalNotes from "../order/internalnotes.component.jsx";
import Duration from "../common/date/duration.component.jsx";
import moment from "moment-timezone";
import CalendarEventStatusBadge from "../scheduling-page/calendareventstatusbadge.component.jsx";
import { getEventName } from '../name-helpers/eventNameHelper';
import { capitalize } from '../name-helpers/nameFormatter';

class CalendarEventAnalytics extends Component {

    constructor(props) {
        super(props)
        this.state = {
            modal: '',
            onRefresh: this.props.onRefresh || function () {
            },
        }

        this.handleRefreshEvent = this.handleRefreshEvent.bind(this)

    }

    handleRefreshEvent(calendarEventId) {
        calendarEventId = calendarEventId || this.props.calendarEvent.id
        this.state.onRefresh(calendarEventId)
    }

    render() {
        if (!this.props.calendarEvent) {
            return <div />
        }

        const calendarEvent = this.props.calendarEvent

        const referenceIds = [
            calendarEvent.attributes.orderIdentifier,
            calendarEvent.attributes.invoiceIdentifier,
            calendarEvent.attributes.quoteIdentifier,
            calendarEvent.attributes.schedulingPageIdentifier,
            calendarEvent.attributes.priceListReferences,
        ]

        const isEmpty = (element) => element == "" || element == null;

        const emptyReferences = referenceIds.every(isEmpty)
        const project = this.props.projectObject
        const contact = calendarEvent.attributes.contact

        const timezoneAbbr = moment.tz.guess()

        return <div className={'row analytics-page py-3 mb-5'}>
            {this.state.modal}
            <div className="col-12 ui-module">
                <div className={"row"}>
                    <div className={"col-12 col-md-6 border-right"}>
                        <h3 className={'m-0 d-flex align-items-center'}>
                            <FormattedMessage
                                id="event_page.analytics.title_label"
                                defaultMessage="{eventName} Page {number}"
                                values={{
                                    number: calendarEvent.attributes.identifier,
                                    eventName: capitalize(getEventName(this.props.intl))
                                }}
                            />
                            <h6 className="ml-2 d-inline mb-0">
                                <CalendarEventStatusBadge status={calendarEvent.attributes.status} />
                            </h6>
                        </h3>
                        <div className={'w-100'}>
                            <div className="form-group mb-0 pl-0">
                                <label className="pl-0 col-12 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="scheduling_page.edit.details.title_label"
                                        defaultMessage="Title"
                                    />
                                </label>
                                <div className="pl-0 col-12">
                                    {calendarEvent.attributes.title}
                                </div>
                            </div>
                        </div>
                        <div className={'w-100'}>
                            <div className="row">
                                <div className="col-6">
                                    <label className="pl-0 col-form-label custom-form-label">
                                        <FormattedMessage
                                            id="scheduling_page.events.listing.headers.start_at_label"
                                            defaultMessage="Start At"
                                        />
                                    </label>
                                    <div>
                                        <FormattedDate
                                            year='numeric'
                                            month='long'
                                            day='numeric'
                                            value={new Date(calendarEvent.attributes.startAt)}
                                        />
                                    </div>
                                    <FormattedTime value={new Date(calendarEvent.attributes.startAt)} /> {timezoneAbbr}
                                </div>
                                <div className="col-6">
                                    <div className={"text-right"}>
                                        <label className="pl-0 col-form-label custom-form-label">
                                            <FormattedMessage
                                                id="scheduling_page.events.listing.headers.end_at_label"
                                                defaultMessage="End At"
                                            />
                                        </label>
                                        <div>
                                            <FormattedDate
                                                year='numeric'
                                                month='long'
                                                day='numeric'
                                                value={new Date(calendarEvent.attributes.endAt)}
                                            />
                                        </div>
                                        <FormattedTime value={new Date(calendarEvent.attributes.endAt)} /> {timezoneAbbr}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'w-100'}>
                            <label className="pl-0 col-form-label custom-form-label">
                                <FormattedMessage
                                    id="calender_event_page.listing.headers.duration_label"
                                    defaultMessage="Duration"
                                />
                            </label>
                            <Duration
                                duration={calendarEvent.attributes.duration}
                            />
                        </div>
                        {!emptyReferences ?
                            <div className={'w-100'}>
                                <label className="pl-0 col-form-label custom-form-label">
                                    <FormattedMessage
                                        id="calendar_event_page.listing.reference_id_placeholder"
                                        defaultMessage="Reference"
                                    />
                                </label>
                                <div>
                                    <DisplayReferences
                                        calendarEvent={calendarEvent.attributes}
                                    />
                                </div>
                            </div>
                            : ''}
                    </div>
                    <div className={"col-12 col-md-6 d-flex"}>
                        <div className={'flex-grow-1'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-0">
                                    <strong>
                                        <FormattedMessage
                                            id="invoice.analytics.contact_label"
                                            defaultMessage="Contact"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <h4 className={'m-0'}>
                                <strong>
                                    <Link to={'/contacts/' + contact.id + '/details'}>
                                        {contact.attributes.name}
                                    </Link>
                                </strong>
                            </h4>
                            <p className={'m-0'}>
                                <a href={'mailto:' + contact.email}>
                                    {contact.attributes.email}
                                </a>
                            </p>
                            {contact.attributes.phoneNumber ?
                                <p className={'m-0'}>
                                    <a href={'tel:' + contact.attributes.phoneNumber}>
                                        {GlobalHelper.formatPhoneNumber(contact.attributes.phoneNumber, contact.attributes.address.countryCode) + contact.attributes.phoneNumbers[0].extension}
                                    </a>
                                </p>
                                : ''
                            }
                        </div>
                        <div className={'text-right'}>
                            <div className={'w-100'}>
                                <label className="col-form-label custom-form-label pt-2">
                                    <strong>
                                        <FormattedMessage
                                            id="scheduling_page.analytics.assign_to_label"
                                            defaultMessage="Assigned to"
                                        />
                                    </strong>
                                </label>
                            </div>
                            <p className={'m-0'}>
                                <Icon value={'user'} />
                                <InlineEditUser
                                    editable={false}
                                    value={
                                        calendarEvent.attributes.user ?
                                            calendarEvent.attributes.user.attributes.name : ''
                                    }
                                    contactId={calendarEvent.attributes.userId}
                                />
                            </p>
                            {calendarEvent.attributes.location ?
                                <div className={'w-100'}>
                                    <label className="col-form-label custom-form-label pt-2">
                                        <strong>
                                            <FormattedMessage
                                                id="scheduling_page.analytics.location_label"
                                                defaultMessage="Location"
                                            />
                                        </strong>
                                    </label>
                                </div>
                                : ''
                            }
                            {calendarEvent.attributes.location ?
                                <p className={'m-0'}>
                                    <Icon value={'map-marker-alt'} /> {calendarEvent.attributes.location}
                                </p>
                                : ''
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-12 ui-module">
                <div className={'w-100'}>
                    <div className="form-group mb-0 pl-0">
                        <label className="pl-0 col-12 col-form-label custom-form-label">
                            <FormattedMessage
                                id="calendar.form.edit.description_label"
                                defaultMessage="Description"
                            />
                        </label>
                        <UrlRegex
                            value={calendarEvent.attributes.description}
                        />
                    </div>
                </div>
            </div>
            <div className="col-12 ui-module">
                <InternalNotes
                    projectObject={project}
                    onRefresh={this.handleRefreshEvent}
                    internalNotes={project ? project.attributes.internalNotes : []}
                />
            </div>
            <div className={'col-12 px-0'}>
                <QuoteEventsTimeLine
                    project={project}
                    calendarEvent={calendarEvent}
                    onUpdate={this.handleRefreshEvent}
                />
            </div>
        </div >
    }

}

export default injectIntl(CalendarEventAnalytics)


// WEBPACK FOOTER //
// ./src/scheduling-page/calendareventanalytics.component.jsx